import { render, staticRenderFns } from "./houseSellList.vue?vue&type=template&id=284298d8&scoped=true"
import script from "./houseSellList.vue?vue&type=script&lang=js"
export * from "./houseSellList.vue?vue&type=script&lang=js"
import style0 from "./houseSellList.vue?vue&type=style&index=0&id=284298d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284298d8",
  null
  
)

export default component.exports